import Utils from '../../Utils';

const STICKY_TOP_MARGIN = 24;
const STICKY_BREAKPOINT = 992;

export default class Sticky {

    static initializeEvents() {
        const stickyEventHandler = () => {
            let headerMobileHeight = 0;
            document.querySelectorAll('.header-mobile').forEach(element => {
                headerMobileHeight += element.offsetHeight;
            });

            const menu = document.getElementById('menu-main');
            headerMobileHeight += menu ? menu.offsetHeight : 0;

            Array.from(document.querySelectorAll('.js-sticky')).forEach(stickyElement => {
                // Skip when element is hidden
                if (getComputedStyle(stickyElement).display === 'none') {
                    return;
                }

                // Preservation of the initial position so as not to calculate the position of a modified element
                if (stickyElement.dataset.initialTop === undefined) {
                    const positionTop = Utils.getOffsetTop(stickyElement);
                    stickyElement.dataset.initialTop = (positionTop < 0 ? 0 : positionTop).toString();
                }

                // Sticky properties
                const stickyTopMargin = stickyElement.dataset.stickyTopMargin ? parseInt(stickyElement.dataset.stickyTopMargin) : STICKY_TOP_MARGIN;
                const stickyBreakpoint = stickyElement.dataset.stickyBreakpoint ? parseInt(stickyElement.dataset.stickyBreakpoint) : STICKY_BREAKPOINT;

                // Scroll limits
                const scrollLimitMin = parseInt(stickyElement.dataset.initialTop) - headerMobileHeight - stickyTopMargin;
                let scrollLimitMax = Utils.getOffsetTop(stickyElement.parentElement) + stickyElement.parentElement.offsetHeight - stickyElement.offsetHeight - headerMobileHeight - stickyTopMargin;
                if (stickyElement.dataset.stickyScrollMax === 'false') {
                    scrollLimitMax = Infinity;
                }

                // Sticky after a breakpoint only
                if (window.innerWidth < stickyBreakpoint) {
                    stickyElement.classList.remove('fixed');
                    stickyElement.style.top = '';
                    stickyElement.style.marginTop = '';
                    stickyElement.style.width = '';

                    return;
                }

                // Reload only when necessary to optimize performance
                const mustReloadElementStyles = (
                    !stickyElement.classList.contains('fixed') ||
                    stickyElement.style.top !== (headerMobileHeight + stickyTopMargin) + 'px' ||
                    stickyElement.style.width !== stickyElement.parentElement.offsetWidth + 'px'
                );

                if (mustReloadElementStyles && window.scrollY >= scrollLimitMin && window.scrollY < scrollLimitMax) {
                    // Sticky
                    stickyElement.classList.add('fixed');
                    stickyElement.style.top = (headerMobileHeight + stickyTopMargin) + 'px';
                    stickyElement.style.marginTop = 0;
                    stickyElement.style.width = stickyElement.parentElement.offsetWidth + 'px';
                } else if (window.scrollY < scrollLimitMin || window.scrollY >= scrollLimitMax) {
                    if (window.scrollY >= scrollLimitMax && stickyElement.style.top !== (scrollLimitMax - window.scrollY + headerMobileHeight + stickyTopMargin) + 'px') {
                        // Sticky with negative margin
                        stickyElement.style.top = (scrollLimitMax - window.scrollY + headerMobileHeight + stickyTopMargin) + 'px';
                    } else if (stickyElement.classList.contains('fixed')) {
                        // Not sticky
                        stickyElement.classList.remove('fixed');
                        stickyElement.style.top = '';
                        stickyElement.style.marginTop = '';
                        stickyElement.style.width = '';
                    }
                }
            });
        };

        stickyEventHandler();
        window.addEventListener('scroll', stickyEventHandler);
        window.addEventListener('resize', stickyEventHandler);
        setTimeout(stickyEventHandler, 1000);
    }

}
